import { useContext } from 'react';
import { AuthContext } from '../context';
export var useAuth = function useAuth() {
  var context = useContext(AuthContext);
  if (!context) throw new Error('Auth context must be use inside AuthProvider');
  return context;
};